import { Component } from '@angular/core';

@Component({
    selector: 'alicia-vogel',
    template: require('./alicia-vogel.component.html'),
})

export class AliciaVogelComponent {    

    constructor() {
    
    }

    navigateURL(url: string) {
        window.open(url, '_blank');
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projects/alicia_vogel/alicia-vogel.component.ts
 **/